import React, { useState } from "react";
import { CommonButton, CommonModal } from "../Input";

// Sub-components
import StepIndicator from "./SendTransaction/StepIndicator";
import Step1ReceiverList from "./SendTransaction/Step1ReceiverList";
import Step2PaymentInfo from "./SendTransaction/Step2PaymentInfo";
import Step3ConfirmTransaction from "./SendTransaction/Step3ConfirmTransaction";
import Step4TransactionDenomination from "./SendTransaction/Step4TransactionDenomination";
import Step5Success from "./SendTransaction/Step5Success";

const SendTransactionModal = ({ show, onHide }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedReceivers, setSelectedReceivers] = useState([]);

  const handleToggleReceiver = (item) => {
    if (selectedReceivers.includes(item.id)) {
      setSelectedReceivers(selectedReceivers.filter((id) => id !== item.id));
    } else {
      setSelectedReceivers([...selectedReceivers, item.id]);
    }
  };

  const handleNext = () => {
    if (currentStep < 5) setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      fullscreen={true}
      backdrop="static"
      headerClassName="bg-light-gray-soft"
      bodyClassName="bg-light-gray-soft"
      footerClassName="bg-light-gray-soft pb-4 pt-0"
      title={
        currentStep < 5 ? (
          <div className="w-100 pe-5">
            <StepIndicator currentStep={currentStep} />
          </div>
        ) : null
      }
      footer={
        currentStep < 5 ? (
          <div className="d-flex justify-content-end gap-3 w-100">
            {currentStep === 1 && (
              <CommonButton variant="outline" className="px-5">
                Add
              </CommonButton>
            )}
            <CommonButton
              variant="outline"
              className="px-5"
              onClick={currentStep === 1 ? onHide : handleBack}
            >
              {currentStep === 1 ? "Close" : "Back"}
            </CommonButton>
            <CommonButton
              className="px-5"
              style={{
                backgroundColor:
                  currentStep === 1 && selectedReceivers.length === 0
                    ? "#94A3B8"
                    : "var(--primary)",
              }}
              disabled={currentStep === 1 && selectedReceivers.length === 0}
              onClick={handleNext}
            >
              Next
            </CommonButton>
          </div>
        ) : null
      }
    >
      <div
        className={
          currentStep === 5
            ? "flex-grow-1 d-flex align-items-center justify-content-center"
            : ""
        }
        style={{ minHeight: "550px" }}
      >
        {currentStep === 1 && (
          <Step1ReceiverList
            selectedReceivers={selectedReceivers}
            onToggleReceiver={handleToggleReceiver}
          />
        )}
        {currentStep === 2 && <Step2PaymentInfo />}
        {currentStep === 3 && <Step3ConfirmTransaction />}
        {currentStep === 4 && <Step4TransactionDenomination />}
        {currentStep === 5 && <Step5Success onClose={onHide} />}
      </div>
    </CommonModal>
  );
};

export default SendTransactionModal;
